module.exports = __webpack_public_path__ + "static/media/ION Home Services Logo White 2.0dde5abd.svg";